module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Jd.6fae5d8c.png";